import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider, {
  IApiResponse,
} from '../../dataProvider/APIDataProvider';
import { IStructuredEssayQuestion, ISubQuestion, TQuestionDifficulty } from '.';

export interface IAdminCreateStructuredQuestion {
  subTopics?: Array<{ subTopic: string; paper: string }>;
  difficulty: TQuestionDifficulty;
  source?: string;
  tags?: string[];
  mainQuestion: string;
  totalMarks: number;
  subQuestions: Array<ISubQuestion>;
}

export interface IUpdateStructuredQuestion {
  id: string;
  subTopics: Array<{ subTopic: string; paper: string }>;
  difficulty: TQuestionDifficulty;
  source?: string;
  totalMarks: number;
  tags?: string[];
  mainQuestion: string;
  subQuestions: Array<ISubQuestion>;
}

export interface IApproveStructuredEssayQuestion {
  id: string;
  isApproved: boolean;
}

const structuredEssayApiDataProvider = new APIDataProvider();

export const generateStructuredEssayQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/generate',
  async (data: any) => {
    const response = await structuredEssayApiDataProvider.upload<
      IApiResponse<any>
    >(`${AdminApiPaths.structuredEssayQuestions}/gptQuestion`, data);
    return response.data;
  }
);

export const adminCreateNewStructuredQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/create',
  async (data: IAdminCreateStructuredQuestion[]) => {
    const response = await structuredEssayApiDataProvider.create(
      `${AdminApiPaths.structuredEssayQuestions}/create`,
      data
    );
    return response.data as IStructuredEssayQuestion[];
  }
);

export const getStructuredEssayQuestionList = createAsyncThunk(
  'admin/structuredEssayQuestions/list',
  async (subTopic: string) => {
    const response = await structuredEssayApiDataProvider.get(
      `${AdminApiPaths.structuredEssayQuestions}/list?subTopicId=${subTopic}`
    );

    return response.data as IStructuredEssayQuestion[];
  }
);

export const getStructuredEssayQuestionById = createAsyncThunk(
  'admin/structuredEssayQuestions/id',
  async (id: string) => {
    const response = await structuredEssayApiDataProvider.getById(
      `${AdminApiPaths.structuredEssayQuestions}/${id}`
    );

    return response.data as IStructuredEssayQuestion;
  }
);

export const approveStructuredEssayQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/approve',
  async (data: IApproveStructuredEssayQuestion) => {
    const { id, ...apiData } = data;
    const response = await structuredEssayApiDataProvider.updateById(
      `${AdminApiPaths.structuredEssayQuestions}/approve/${id}`,
      apiData
    );
    return response.data as IStructuredEssayQuestion;
  }
);

export const deleteStructuredEssayQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/delete',
  async (data: { id: string }) => {
    const response = await structuredEssayApiDataProvider.updateById(
      `${AdminApiPaths.structuredEssayQuestions}/delete/${data.id}`,
      data
    );
    return response.data as IStructuredEssayQuestion;
  }
);

export const updateStructuredEssayQuestion = createAsyncThunk(
  'admin/structuredEssayQuestions/update',
  async (data: IUpdateStructuredQuestion) => {
    const { id, ...apiData } = data;
    const response = await structuredEssayApiDataProvider.updateById(
      `${AdminApiPaths.structuredEssayQuestions}/${id}`,
      apiData
    );
    return response.data as IStructuredEssayQuestion;
  }
);
